import i18n from "i18next";

export const enum FitnessGoals {
    GainMuscle = "gainMuscle",
    GetInShape = "getInShape",
    LoseWeight = "loseWeight",
    BeHealthy = "beHealthy",
    GetActive = "getActive",
}

export const goalTextById: { [key in FitnessGoals]?: string } = {
    [FitnessGoals.GainMuscle]: i18n.t("muscle_gain"),
    [FitnessGoals.LoseWeight]: i18n.t("weight_loss"),
    [FitnessGoals.GetActive]: i18n.t("fitness"),
    [FitnessGoals.BeHealthy]: i18n.t("stay_active"),
    [FitnessGoals.GetInShape]: i18n.t("get_in_shape"),
};

export const goalTextByIdChartImage: { [key in FitnessGoals]?: string } = {
    [FitnessGoals.GainMuscle]: i18n.t("gain_muscle"),
    [FitnessGoals.GetInShape]: i18n.t("get_in_shape"),
    [FitnessGoals.LoseWeight]: i18n.t("lose_weight"),
    [FitnessGoals.GetActive]: i18n.t("stay_fit"),
    [FitnessGoals.BeHealthy]: i18n.t("stay_active"),
};

export const calisthenicsActionPlanTextByGoal: { [key in FitnessGoals]?: string } = {
    [FitnessGoals.GainMuscle]: i18n.t("gain_muscle"),
    [FitnessGoals.LoseWeight]: i18n.t("lose_weight"),
    [FitnessGoals.GetActive]: "reach your peak form",
    [FitnessGoals.BeHealthy]: "reach your peak form",
    [FitnessGoals.GetInShape]: i18n.t("get_in_shape"),
};

export const calisthenicsEventTextByGoal: { [key in FitnessGoals]?: string } = {
    [FitnessGoals.GainMuscle]: i18n.t("gain_muscle"),
    [FitnessGoals.LoseWeight]: i18n.t("lose_weight"),
    [FitnessGoals.GetActive]: "be at your peak form",
    [FitnessGoals.BeHealthy]: "be at your peak form",
    [FitnessGoals.GetInShape]: i18n.t("get_in_shape"),
};

export const goalIngTextById: Record<FitnessGoals, string> = {
    [FitnessGoals.GainMuscle]: i18n.t("gaining_muscle"),
    [FitnessGoals.LoseWeight]: i18n.t("losing_weight"),
    [FitnessGoals.GetInShape]: i18n.t("getting_in_shape"),
    [FitnessGoals.BeHealthy]: i18n.t("being_healthy"),
    [FitnessGoals.GetActive]: i18n.t("getting_active"),
};
